import type { SVGProps } from 'react';

const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3m0 2c.5 0 .9.38.97.86l-6.48 3.7c-.31.17-.69.17-.99 0l-6.48-3.7A.99.99 0 0 1 5.99 7zm0 10H6c-.55 0-1-.45-1-1v-5.85l5.51 3.15c.46.26.97.39 1.49.39s1.03-.13 1.49-.39L19 10.15V16c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgEmail;
